import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import HomePage from "./pages/home";
import Activation from "./pages/activation";
import ActivationUser from "./pages/activation-user";
import { lincenseKey } from "./devextreme-license";
import config from "devextreme/core/config";
import { AuthProvider } from "./contexts/authContext";

config({
  licenseKey: lincenseKey,
});

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/company/verification/:verification_code/:Cod_fiscal/:Email"
            element={<Activation />}
          />
          <Route
            path="/company/verification-user/:verification_code/:Cod_fiscal/:Email"
            element={<ActivationUser />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
